import React,{useEffect} from 'react'
import Banner from '../banner/Banner'
import About from './About'
import Choose from './Choose'
import Service from './Service'
import Action from './Action'
import Team from './Team'
import Testimonials from './Testimonials'
import Question from './Question'
import Contact from './Contact'
import Client from './Client'

const Main = () => {
  
  return (
    <main className='main'>
        <Banner/>
        <Client/>
        <About/>
        <Choose/>
        <Service/>
        <Action/>
        {/* <Team/> */}
        <Testimonials/>
        <Question/>
        <Contact/>
    </main>
   
  )
}

export default Main
